import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";

export const StyledHeadSection = styled.section`
  background: ${({ theme }) => theme.colorsV2.shyft.cream};
  .head-section {
    padding: 16px;
    padding: 56px 0 40px;
    .careers {
      margin: 0 0 8px;
    }
    .job-info {
      @media only screen and (max-width: 767px) {
        flex-direction: column;
      }
    }
    .team {
      color: ${({ theme }) => theme.colorsV2.gray.shade_400};
      position: relative;
      padding: 0 34px 0 0;
      &:after {
        content: "";
        position: absolute;
        height: 80%;
        width: 2px;
        top: 50%;
        transform: translate(0, -50%);
        color: ${({ theme }) => theme.colorsV2.gray.shade_400};
        background: ${({ theme }) => theme.colorsV2.gray.shade_400};
        margin: 0 16px;
      }
      @media only screen and (max-width: 767px) {
        margin: 0 0 8px;
        &:after {
          content: none;
        }
      }
    }
    .role {
      color: ${({ theme }) => theme.colorsV2.primary.shade_900};
    }
    .chips {
      margin: 28px 0;
      flex-wrap: wrap;
      @media only screen and (max-width: 767px) {
        margin: 20px 0;
        flex-wrap: wrap;
      }
    }
    @media only screen and (max-width: 767px) {
      margin: 40px 0;
    }
  }
  .container {
    @media only screen and (max-width: 767px) {
      padding: 0 8px;
    }
  }
`;

export const StyledChip = styled(FlexDiv)`
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 32px;
  margin: 4px 16px 4px 0;
`;

export const ShadowButton = styled(Button)`
  box-shadow: 0px 10px 20px
      rgba(${({ theme }) => theme.colors.shadows.purple_3}, 0.18),
    0px 2px 6px rgba(${({ theme }) => theme.colors.shadows.purple_3}, 0.12),
    0px 0px 1px rgba(${({ theme }) => theme.colors.shadows.black}, 0.04);
  font-size: 16px;
  padding: 14px 48px;
  svg {
    height: 24px;
    width: 24px;
  }
  @media only screen and (max-width: 767px) {
    font-size: 14px;
    padding: 14px 24px;
    svg {
      height: 16px;
      width: 16px;
    }
  }
`;
